import { render, staticRenderFns } from "./RicercaUtente.vue?vue&type=template&id=22886c61&"
import script from "./RicercaUtente.vue?vue&type=script&lang=js&"
export * from "./RicercaUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RicercaUtente.vue"
export default component.exports